import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';
import { InputAdornment, SelectChangeEvent } from '@mui/material';
import { useContext } from 'react';
import { SessionContext } from '../Contexts/SessionContext';
import WarningPopup from '../Popups/WarningPopup';
import { Checkbox, Typography, Select, MenuItem } from '@mui/material';
import { CounterBadge } from '../Utilities/CounterBadge';
import Line from '../Utilities/Line';

const siteOperationOptions = [
    { id: 0, label: 'Offices' },
    { id: 1, label: 'Research and Development' },
    { id: 2, label: 'Light Industrial' },
    { id: 3, label: 'General Industrial' },
    { id: 4, label: 'Storage and Distribution' },
]

export default function SiteOperations() {
    const { sessionState, setSessionField } = useContext(SessionContext);

    const siteOpChecked = sessionState?.secondaryFilters.siteOperationsChecked ?? false;
    const isMin = sessionState?.secondaryFilters.siteOperationIsMin ?? true;
    const siteOperationsPercentage = sessionState?.secondaryFilters.siteOperationPercentage;
    const selected = sessionState?.secondaryFilters?.siteOperation ?? 0;

    const ondropdownChange = (value: SelectChangeEvent<number>) => {
        setSessionField('secondaryFilters.siteOperation', value.target.value)
    }
    const onRadioChange = (value: string) => {
        setSessionField('secondaryFilters.siteOperationIsMin', value === 'true')
    }
    const onCheckboxChange = (value: boolean) => {
        setSessionField('secondaryFilters.siteOperationsChecked', value)
    }

    if (sessionState.tripRateMain !== "02") return null;

    return (
        <Grid container size={12} component={Paper} sx={{ position: 'relative' }}>
            <CounterBadge value={'7'} />
            <Grid container size={12} alignItems="center" justifyContent="center" sx={{ position: "relative" }}>
                <Typography textAlign="center">
                    Site Operations Breakdown
                </Typography>
            </Grid>
            <Line />
            <Grid size={12}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <InputLabel>
                        All Sites Selected
                    </InputLabel>

                    <Checkbox
                        name="siteOperationsChecked"
                        checked={siteOpChecked}
                        onChange={(_, checked) => onCheckboxChange(checked)}
                    />

                    <WarningPopup
                        title="Warning on Site Operations Breakdown"
                        content="By default, all surveys are selected. However, be aware that some sites have unknown Operations Breakdown splits, and if users activate the Site Operations Breakdown selection by unticking the box, then all sites with unknown levels of Site Operations Breakdown will be excluded from the selected list."
                        type="warning"
                    />

                </Stack>
            </Grid>
            <Grid size={12}>
                <Stack direction={"row"}>
                    <Typography textAlign="center">Site Operations</Typography>
                    <Select
                        name={'siteOperation'}
                        value={selected}
                        disabled={siteOpChecked}
                        onChange={(value) => ondropdownChange(value)}>
                        {siteOperationOptions && siteOperationOptions.map((level, index) => (
                            <MenuItem key={level.id + index} value={level.id}>
                                {level.label}
                            </MenuItem>
                        ))}

                    </Select>
                </Stack>
            </Grid>

            <Grid size={6}>
                <FormControl>
                    <RadioGroup
                        value={String(isMin)}
                        onChange={(e) =>
                            onRadioChange(e.target.value)
                        }
                    >
                        <FormControlLabel
                            value="true"
                            control={<Radio disabled={siteOpChecked} />}
                            label="Minimum"
                        />
                        <FormControlLabel
                            value="false"
                            control={<Radio disabled={siteOpChecked} />}
                            label="Maximum"
                        />
                    </RadioGroup>
                </FormControl>
            </Grid>

            {!siteOpChecked && (
                <Grid size={6}>
                    <Stack spacing={1}>
                        <Grid size={12}>
                            <TextField
                                name="siteOperationPercentage"
                                value={siteOperationsPercentage}
                                type="number"
                                onChange={(e) => setSessionField('secondaryFilters.siteOperationPercentage', Number(e.target.value))}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                                inputProps={{
                                    min: 0,
                                    max: 100,
                                }}
                            />
                        </Grid>
                    </Stack>
                </Grid>
            )}
        </Grid>
    );
}
